import { useCallback } from 'react'
import { useKeyboardShortcut } from '../../hooks'
import { icons } from '../../styles/images'
import { Icon } from '../atoms/Icon'
import NoStyleAnchor from '../atoms/NoStyleAnchor'
import GTButton from '../atoms/buttons/GTButton'
import { CollapsedIconContainer } from '../navigation_sidebar/NavigationLink'
import Tip from '../radix/Tip'

const FEEDBACK_MAILTO = 'mailto:john@johnglomerate.com?subject=General%20Task%20feedback'

interface ShareFeedbackButtonProps {
    isCollapsed?: boolean
}
const ShareFeedbackButton = ({ isCollapsed = false }: ShareFeedbackButtonProps) => {
    useKeyboardShortcut(
        'sendFeedback',
        useCallback(() => {
            window.location.href = FEEDBACK_MAILTO
        }, [])
    )

    if (isCollapsed) {
        return (
            <Tip content="Share Feedback" side="right">
                <NoStyleAnchor href={FEEDBACK_MAILTO}>
                    <CollapsedIconContainer>
                        <Icon icon={icons.megaphone} />
                    </CollapsedIconContainer>
                </NoStyleAnchor>
            </Tip>
        )
    }
    return (
        <NoStyleAnchor href={FEEDBACK_MAILTO}>
            <GTButton value="Share feedback" styleType="secondary" fitContent={false} />
        </NoStyleAnchor>
    )
}

export default ShareFeedbackButton
